import { Box, Skeleton, Stack, useMediaQuery, useTheme } from "@mui/material"
import { useMemo } from "react"
import fp from "lodash/fp"

import { PlotContainer } from "widgets/styled/containers"
import { PIE_CHART_PLOT_SIZE } from "widgets/plots/configuration/pie"

const PieChartSkeleton = () => {
  const theme = useTheme()
  const isDownMd = useMediaQuery(theme.breakpoints.down("md"))
  const isDownLg = useMediaQuery(theme.breakpoints.down("lg"))

  const surfaceSize = useMemo(() => {
    return isDownMd
      ? PIE_CHART_PLOT_SIZE.sm
      : isDownLg
      ? PIE_CHART_PLOT_SIZE.md
      : PIE_CHART_PLOT_SIZE.lg
  }, [isDownMd, isDownLg])

  const pieSize = useMemo(() => surfaceSize / 1.13, [surfaceSize])

  return (
    <PlotContainer maxWidth="xl" type={"pie"}>
      <Box mb={2.5}>
        <Skeleton variant="rounded" width={150} />
      </Box>
      <Stack
        direction={isDownLg ? "column" : "row"}
        justifyContent="center"
        alignItems="center"
        gap={2}
        overflow="hidden"
        textAlign="center"
      >
        <Stack
          width={surfaceSize}
          height={surfaceSize}
          justifyContent="center"
          alignItems="center"
        >
          <Skeleton variant="circular" width={pieSize} height={pieSize} />
        </Stack>

        <Box
          display="flex"
          flexWrap="wrap"
          justifyContent="center"
          gap={1.5}
          maxWidth={surfaceSize}
          flexDirection={isDownLg ? "row" : "column"}
        >
          {fp
            .times((index) => index)(4)
            .map((label) => (
              <Skeleton key={label} variant="rounded" style={{ minWidth: 70 }} />
            ))}
        </Box>
      </Stack>
    </PlotContainer>
  )
}

export default PieChartSkeleton
